<template>
  <div class="wa__info-panel">
    <div class="wa__info-header">
      <span>Información</span>
      <button class="wa__info-close" @click="$emit('close')">
        <i class="fas fa-times"></i>
      </button>
    </div>
    <div class="wa__info-body">
      <div class="wa__info-item">
        <span class="wa__info-label">Empleado</span>
        <span class="wa__info-value">{{ employeeName }}</span>
      </div>
      <div class="wa__info-item">
        <span class="wa__info-label">Teléfono</span>
        <span class="wa__info-value">{{ conversation.phoneNumber || "—" }}</span>
      </div>
      <div class="wa__info-item">
        <span class="wa__info-label">Employee ID</span>
        <span class="wa__info-value">{{ conversation.employeeId || "—" }}</span>
      </div>
      <div class="wa__info-item">
        <span class="wa__info-label">Estado</span>
        <span class="wa__info-value">{{ conversation.status || "—" }}</span>
      </div>
      <div class="wa__info-item">
        <span class="wa__info-label">Modo</span>
        <span class="wa__info-value">{{ conversation.mode || "—" }}</span>
      </div>
      <div v-if="conversation.profile?.branch" class="wa__info-item">
        <span class="wa__info-label">Sucursal</span>
        <span class="wa__info-value">{{ conversation.profile.branch }}</span>
      </div>
      <div v-if="conversation.profile?.city" class="wa__info-item">
        <span class="wa__info-label">Ciudad</span>
        <span class="wa__info-value">{{ conversation.profile.city }}</span>
      </div>
      <div v-if="conversation.profile?.dni" class="wa__info-item">
        <span class="wa__info-label">Cédula empleado</span>
        <span class="wa__info-value">{{ conversation.profile.dni }}</span>
      </div>
      <div v-if="conversation.coverageZone" class="wa__info-item">
        <span class="wa__info-label">Zona de cobertura</span>
        <span class="wa__info-value">{{ conversation.coverageZone }}</span>
      </div>
      <div
        v-if="conversation.assignedAdvisorName"
        class="wa__info-item"
      >
        <span class="wa__info-label">Asesor asignado</span>
        <span class="wa__info-value">{{
          conversation.assignedAdvisorName
        }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "WaInfoPanel",
  props: {
    conversation: {
      type: Object,
      required: true,
    },
    employeeName: {
      type: String,
      default: "—",
    },
  },
  emits: ["close"],
};
</script>
